<template>
  <div id="app">
    <router-view v-if="inited"/>
  </div>
</template>

<script>
// import {setToken} from "@/api-nt/request/auth";
// import {setNickName} from "@/api-nt/request/auth";
// import ExternalApi from "@/api-nt/external-api";
// import StorageUtil from "@/utils/StorageUtil";
import axios from 'axios'
// import {loginMethod} from "@/api-nt/login/loginMethod";

export default {
  name: 'App',
  data() {
    return {
      user: "",
      token: "",
      nurton: "",
      inited: true
    }
  },
  watch:{
    $route: {
      handler: async function () {
        if (this.$route.path === '/') {
          return
        }
        // this.login();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    login() {
      if (this.$route.path === '/') {
        return
      }
      // this.token= this.$route.query.token
      // this.user= this.$route.query.user
      // this.nurton= this.$route.query.nurton
      // if(this.token&&this.user){
      //   loginMethod.serverLogin({token:this.token,user: this.user}).then(res => {
      //     loginMethod.userSet(res).then(userset => {
      //       setToken(userset.data.token)
      //       StorageUtil.insert("Admin-Token",userset.data.token)
      //       this.$store.commit('UPDATE_USER_INFO',userset.data)
      //       setNickName( userset.data.user)
      //       this.inited = true
      //     })
      //   })

      // }else if (this.nurton) {
      //   loginMethod.unUserLogin({nurton: this.nurton}).then(res => {
      //     setToken(res.data.token)
      //     StorageUtil.insert("Admin-Token",res.data.token)
      //     this.$store.commit('UPDATE_USER_INFO',res.data)
      //     setNickName( res.data.user)
      //     this.inited = true
      //   })
      // }else {
      //   loginMethod.getUser().then(res => {
      //     this.$store.commit('UPDATE_USER_INFO',res.data)
      //     setToken(res.data.token)
      //     StorageUtil.insert("Admin-Token",res.data.token,null)
      //     setNickName( res.data.user)
      //     this.inited = true
      //   })
      // }
    },
  },
}
</script>

<style lang="scss">
// @import "./assets/font/font.css";
#app {
  font-family: "PuHui RE";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $text-color;
  width: 100%;
  height: 100%;
}
</style>
